import React from "react";
import HeroSection from "../components/Hero";
import AboutSection from "../components/AboutUs";
import FAQSection from "../components/FAQ";
import ServicesSection from "../components/Services";
import ContactSection from "../components/Contact";
import WhyChooseUsSection from "../components/WhyChooseUs";
import YouTubeShortsSlider from "../components/YoutubeShortsSlider";

function HomePage() {
  return (
    <div className="App">
      <HeroSection />
      <ContactSection />
      <YouTubeShortsSlider />
      <AboutSection />
      <WhyChooseUsSection />
      <ServicesSection />
      <div id="faq-section">
        <FAQSection />
      </div>
    </div>
  );
}

export default HomePage;